import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "../../layout";
import { IdentityList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { IdentityCreateInitializer } from "./create/initializer";

const IdentityRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<IdentityList />} />
        <Route path={`-create/*`} element={<IdentityCreateInitializer />} />
      </Routes>
    </Layout>
  );
};

export default IdentityRoute;
